module.exports = __webpack_public_path__ + "img/currentTarget.171ac0bf.png";